import ReportsTypes from './Reports.types';

export const getManagementLeaveReport = (data: any) => ({
	type: ReportsTypes.GET_MANAGEMENT_LEAVE_REPORT,
	payload: data,
});

export const getManagementLeaveReportSuccess = (data: any) => ({
	type: ReportsTypes.GET_MANAGEMENT_LEAVE_REPORT_SUCCESS,
	payload: data,
});

export const getManagementLeaveReportFailure = (error: unknown) => ({
	type: ReportsTypes.GET_MANAGEMENT_LEAVE_REPORT_FAILURE,
	payload: error,
});

export const managementLeaveReportReset = () => ({
	type: ReportsTypes.MANAGEMENT_LEAVE_REPORT_RESET,
});

export const getDesignationLeaveReport = (data: any) => ({
	type: ReportsTypes.GET_DESIGNATION_LEAVE_REPORT,
	payload: data,
});

export const getDesignationLeaveReportSuccess = (data: any) => ({
	type: ReportsTypes.GET_DESIGNATION_LEAVE_REPORT_SUCCESS,
	payload: data,
});

export const getDesignationLeaveReportFailure = (error: unknown) => ({
	type: ReportsTypes.GET_DESIGNATION_LEAVE_REPORT_FAILURE,
	payload: error,
});

export const designationLeaveReportReset = () => ({
	type: ReportsTypes.DESIGNATION_LEAVE_REPORT_RESET,
});

export const getMonthlyAttendanceSummaryReport = (data: any) => ({
	type: ReportsTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT,
	payload: data,
});

export const getMonthlyAttendanceSummaryReportSuccess = (data: any) => ({
	type: ReportsTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_SUCCESS,
	payload: data,
});

export const getMonthlyAttendanceSummaryReportFailure = (error: unknown) => ({
	type: ReportsTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_FAILURE,
	payload: error,
});

export const monthlyAttendanceSummaryReportReset = () => ({
	type: ReportsTypes.MONTHLY_ATTENDANCE_SUMMARY_REPORT_RESET,
});

export const getMonthlyCheckoutReport = (data: any) => ({
	type: ReportsTypes.GET_MONTHLY_CHECKOUT_REPORT,
	payload: data,
});

export const getMonthlyCheckoutReportSuccess = (data: any) => ({
	type: ReportsTypes.GET_MONTHLY_CHECKOUT_REPORT_SUCCESS,
	payload: data,
});

export const getMonthlyCheckoutReportFailure = (error: unknown) => ({
	type: ReportsTypes.GET_MONTHLY_CHECKOUT_REPORT_FAILURE,
	payload: error,
});

export const monthlyCheckoutReportReset = () => ({
	type: ReportsTypes.MONTHLY_CHECKOUT_REPORT_RESET,
});
